module.exports = __webpack_public_path__ + "img/empty-conversations@2x.a3693ef1.png";